import { render, staticRenderFns } from "./RsaPersonaRiferimentoComponent.vue?vue&type=template&id=aa8ff666"
import script from "./RsaPersonaRiferimentoComponent.vue?vue&type=script&lang=js"
export * from "./RsaPersonaRiferimentoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports